// validate.ts — lenient form validation helpers.
//
// The bias everywhere is FAIL-OPEN for lead capture: an anxious injured
// visitor must never lose their chat over formatting. The server normalizes
// phone numbers to E.164 later (Haiku extraction/backfill), so the client
// only checks "plausibly a phone" and sends the raw trimmed string.

/** True when the string contains a plausible phone number: 7–20 digits after
 *  stripping every non-digit ("(604) 555-0123", "+1 604 555 0123 ext 2" all
 *  pass; "call me on WhatsApp" does not). */
export function isPlausiblePhone(raw: string): boolean {
  const digits = raw.replace(/\D/g, "");
  return digits.length >= 7 && digits.length <= 20;
}
